<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('./assets/sass/flex.css');
@import url('./assets/sass/common.scss');
@import url('../static/fa/css/font-awesome.css');
@import url('//at.alicdn.com/t/c/font_1665910_82wzvyygwcg.css');
.cp{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue